// v-animate 动画指令，支持动态动画名
export default {
  inserted (el, binding) {
    if (!binding.value) return
    el.classList.add('animate__animated', `animate__${binding.value}`)
    el.addEventListener('animationend', () => {
      el.classList.remove('animate__animated', `animate__${binding.value}`)
    }, { once: true })
  },
  update (el, binding) {
    if (!binding.value) return
    el.classList.add('animate__animated', `animate__${binding.value}`)
    el.addEventListener('animationend', () => {
      el.classList.remove('animate__animated', `animate__${binding.value}`)
    }, { once: true })
  }
}
